/* eslint-disable import/no-duplicates */
import Vue from 'vue';
import Quasar from 'quasar';
import { Notify } from 'quasar';
import Vuelidate from 'vuelidate';
import VueAxios from 'vue-axios';
import axios from 'axios';
import { cacheAdapterEnhancer } from 'axios-extensions';
import * as onLoad from 'vue-onload';
import App from './App.vue';
import router from './router';
import store from './store/index';

// Util
import util from './globals/utility';

// Quasar stuff
import './styles/quasar.styl';
import 'quasar-framework/dist/quasar.ie.polyfills';
import 'quasar-extras/animate';
import 'quasar-extras/material-icons';
import 'quasar-extras/mdi';
import '@mdi/font/css/materialdesignicons.css';

// Vuelidate to validate forms
Vue
  .use(Vuelidate)
  .use(onLoad.plugin)
  .use(Quasar, {
    config: {},
  });

Vue.prototype.$isEnglish = store.state.stringsStore.language === 'en';
Vue.prototype.$util = util;

// Add a response interceptor
axios.interceptors.response.use(response => response,
  (error) => {
  // Sign out if unathorized
    if (error.response && error.response.status === 401) {
      store.dispatch('authLogout')
        .then(() => {
          router.push('/login');
          if (router.history._startLocation !== '/') {
            Notify.create({
              color: 'warning',
              position: 'top-right',
              message: store.state.stringsStore.language === 'en' ? 'You are not authenticated' : 'Jij bent niet ingelogd',
            });
          }
        });
    }
    return Promise.reject(error);
  });

// Config of Axios
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.create({
  withCredentials: true,
  credentials: 'same-origin',
  headers: { 'content-type': 'application/x-www-form-urlencoded', 'Cache-Control': 'no-cache' },
  // To make a request cacheable, or to use the response cache from a previous request use "{ useCache: true }" in the request.
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false, cacheFlag: 'useCache' }),
});

Vue.directive('permission', {
  bind(el, binding, vnode) {
    if (!store.state.meStore.me.rights.includes(binding.value)) {
      // replace HTMLElement with comment node
      const comment = document.createComment(' ');
      Object.defineProperty(comment, 'setAttribute', {
        value: () => undefined,
      });
      vnode.elm = comment;
      vnode.text = '';
      vnode.isComment = true;
      vnode.context = undefined;
      vnode.tag = undefined;
      vnode.data.directives = undefined;

      if (vnode.componentInstance) {
        vnode.componentInstance.$el = comment;
      }

      if (el.parentNode) {
        el.parentNode.replaceChild(comment, el);
      }
    }
  },
});

// Let vuejs work with Axios
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
